module.exports = __webpack_public_path__ + "img/bianpao_des_4.6fd15315.jpg";